import { Typography } from 'antd'
import styled, { css } from 'styled-components'

const StyledIngredientExplanationParagraph = styled(Typography.Paragraph)`
  margin-bottom: 0 !important;
  ${props =>
    props.isRemoved &&
    css`
      color: #ccc;
    `};
`

export default StyledIngredientExplanationParagraph
